import React from 'react';
import { profile } from '../data/content';

export default function About() {
  return (
    <section className="about" id="about">
      <p className="section-title">About</p>
      <h2>Summary</h2>
      <p className="about__summary">{profile.summary}</p>
    </section>
  );
}
